import { Grid } from '@material-ui/core';
import { Button, Col, Row } from 'antd';
import React from 'react';
import DetailItem from '../../../../CSIComponents/DetailItem';
import styles from '../../index.module.css'

const MeetingPaymentView = (props: any) => {
    const detailData = [
        { label: 'American Express', value: props.paymentData.amex, span: 6 },
        { label: 'Diners Club', value: props.paymentData.dinersclub, span: 6 },
        { label: 'Discover Card', value: props.paymentData.discovery, span: 6 },
        { span: 5 },
        { label: 'JCB', value: props.paymentData.jcb, span: 6 },
        { label: 'MasterCard', value: props.paymentData.mastercard, span: 6 },
        { label: 'Visa', value: props.paymentData.visa, span: 6 },
        { span: 5 },
        { label: 'Corporate Meeting Card', value: props.paymentData.corporatemeetingcard, span: 6 },
        { label: 'Funds Held On Credit Card', value: props.paymentData.fundsheld, span: 6 },
        { label: 'Advanced Deposit Required', value: props.paymentData.advanceddepositrequired, span: 6 },
        { span: 5 },
        { label: 'Max Group Charge on Credit Card', value: props.paymentData.ismaxamount, span: 6 },
        { label: 'If so, what is the Maximum Amount', value: props.paymentData.maxamount, span: 6 },
        { span: 10 },
        { label: 'Direct Bill', name: 'isDirectBill', span: 6, value: props.paymentData.isDirectBill },
        { label: 'Direct Bill Payment Terms', name: 'directBillPaymentTerms', span: 6, value: props.paymentData.directBillPaymentTerms },
        { span: 10 },
        { label: 'Minimum Spend to Direct Bill', name: 'isMinimumSpendToDirectBill', span: 6, value: props.paymentData.isMinimumSpendToDirectBill },
        { label: 'If so, what is the amount (USD)', name: 'minimumSpendToDirectBillAmount', span: 6, value: props.paymentData.minimumSpendToDirectBillAmount },
        { span: 10 },
        { label: 'Maximum Spend to Direct Bill', name: 'isMaximumSpendToDirectBill', span: 6, value: props.paymentData.isMaximumSpendToDirectBill  },
        { label: 'If so, what is the amount (USD)', name: 'maximumSpendToDirectBillAmount', span: 6, value: props.paymentData.maximumSpendToDirectBillAmount },
        { span: 10 },
    ]

    return (
        <>
            <div className={styles.outCon}>
                <div className={styles.inCon}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '10px' }}>Meeting Payment</div>
                    <Button type='primary' className='db-edit-btn' onClick={() => { props.setEditFlag(true); window.editFunction(); props.setOneNavDisabled(true) }}>Edit</Button>
                </div>
                <Grid item xs={12} className={styles.pdLeft}>
                    <Row gutter={24}>
                        {detailData.map((item, i) => {
                            return item.label ? <Col span={item.span} key={i} className="col-margin">
                                <DetailItem value={item.value} label={item.label} />
                            </Col> : <Col span={item.span} key={i}></Col>
                        })
                        }
                    </Row>
                </Grid>
            </div>
        </>
    )
}
export default MeetingPaymentView;
